import { STATE, USERSTATES } from "../../classes/Enum";
import { useEffect, useState } from "react";
import { useAuth } from "../AuthProvider"; // <-- adjust path if needed
import { isAdminUser } from "../../helper/admin";
import { register } from "../../api/auth"; // <-- or from "../../api/user"
import "../../styles/login.css";
import { sendPasswordResetLink } from "../../api/user";
import RecentlyViewedMenuWidget from "./RecentlyViewedMenuWidget";

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

function isBirthdayValid(birthday) {
  if (!birthday) return false;

  // Check format DD/MM/YYYY
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = birthday.match(regex);
  if (!match) return false;

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);

  // Basic range checks
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;

  // Create date object
  const date = new Date(year, month - 1, day);
  console.log(date);

  // Validate actual date (handles invalid like 31/02/2020)
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return false;
  }

  // Check it's before today
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  console.log(today);

  if (date >= today) return false;

  return true;
}

const ForgotPasswordComponent = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  async function handleClick() {
    if (!email) {
      setErrorMessage("Please enter an email.");
      return;
    }

    try {
      await sendPasswordResetLink(email);
      setSent(true);
    } catch (e) {
      setErrorMessage(e.message || "Failed to send reset email.");
    }
  }

  return (
    <div id="login-container">
      <h1>FORGOT PASSWORD</h1>

      <div id='login'>

      {sent ? (
        <div className="success-message">
          If an account exists, a reset link has been sent.
        </div>
      ) : (
        <>
          <input className="register-input-box" placeholder="Email"
            value={email} onChange={(e) => setEmail(e.target.value)} />

          {errorMessage && <h3 className="error-message">{errorMessage}</h3>}

          <button className={`button register ${email ? "is-active" : ""}`} onClick={handleClick}>
            Submit
          </button>
        </>
      )}
      </div>
    </div>
  );
};

const RegisterComponent = ({ setUserState }) => {
  const {login} = useAuth();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [tikTokName, setTikTokName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const isActive =
    email.trim() !== "" &&
    firstName.trim() !== "" &&
    lastName.trim() !== "" &&
    birthday.trim() !== "" &&
    tikTokName.trim() !== "";
  
    const [capsOn, setCapsOn] = useState(false);

    function handleKeyEvent(e) {
      setCapsOn(e.getModifierState("CapsLock"));
    }

  const handleRegister = async () => {
    console.log("Registering..");
    setErrorMessage(null);

    // let success, err = validateEmail(email);
    // if (!success) {
    //   setErrorMessage(err.error);
    //   return;
    // }

    // success, err = validateBirthday(birthday);
    // if (!success) {
    //   setErrorMessage(err.error);
    //   return;
    // }

    setErrorMessage(null);
    try {
      const status = await register(
        email,
        password,
        firstName,
        lastName,
        birthday,
        tikTokName
      );
      if ((status === 201) || (status === 200)) {
        login(email, password);
        setUserState(null);
        window.location.reload();
      } else {
        setErrorMessage("Registration failed. Please try again.");
      }
    } catch (e) {
      setErrorMessage(e.message || "Registration failed.");
    }
  };

  return (
    <div id="login-container">
      <form onSubmit={(e) => e.preventDefault()}>
        <div id="login">
          <input className="register-input-box" placeholder="First name"
            value={firstName} onChange={(e) => setFirstName(e.target.value)}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}/>

          <input className="register-input-box" placeholder="Last name"
            value={lastName} onChange={(e) => setLastName(e.target.value)}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}/>

          <input className="register-input-box" placeholder="Email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}/>

          <input className="register-input-box" type="date"
            value={birthday} onChange={(e) => setBirthday(e.target.value)} />

          <input className="register-input-box" type="password" placeholder="Password"
            value={password} onChange={(e) => {
              const cleaned = e.target.value.replace(
                /[^A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g,
                ''
              );
              setPassword(cleaned);
            }}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}/>

          <input className="register-input-box" placeholder="TikTok Username"
            value={tikTokName} onChange={(e) => setTikTokName(e.target.value)}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}/>
        </div>
      </form>

      {capsOn && <p className="caps-warning">Caps Lock is on</p>}
      {errorMessage && <p className="error-message">{errorMessage}</p>}

      <button className={`button register ${isActive ? "is-active" : ""}`} onClick={handleRegister}>
        Start your collecting journey!
      </button>
    </div>
  );
};

/* =========================
   LOGIN
========================= */
const LoginComponent = ({ setUserState }) => {
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const isActive = email.trim() !== "" && password.trim() !== "";
  const [capsOn, setCapsOn] = useState(false);

    function handleKeyEvent(e) {
      setCapsOn(e.getModifierState("CapsLock"));
    }

  async function handleLogin() {
    setLoading(true);
    setErrorMessage(null);
    try {
      await login(email, password);
      setUserState(null);
    } catch (e) {
      setErrorMessage(e.message || "Login failed.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div id="login-container">

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
      >
        <div id="login">
          <input className="login-box" placeholder="Email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}
            />

          <input className="password-box" type="password" placeholder="Password"
            value={password} onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}/>
        </div>
        {capsOn && <p className="caps-warning">Caps Lock is on</p>}
        <button className={`button login-button ${isActive ? "active" : ""}`}   disabled={!isActive || loading}>
          {loading ? "Logging in..." : "Log In"}
        </button>
        <button onClick={() => setUserState(USERSTATES.FORGOT)}>
          <h3 className="row" style={{fontWeight:"unset"}}>Forgot password?</h3>
        </button>
      </form>
      {}
      {errorMessage && <div className="login-error">{errorMessage}</div>}
    </div>
  );
};

const SocialComponent = () => {
  return <div className="social-container">
    <p>Join the community</p>
    <div className="social-icons">
      <a className="social-button" href="https://discord.gg/vCakE9JgZf" target="_blank" rel="noopener noreferrer">
        <img src="/assets/svgs/discord.svg" alt="Discord" />
      </a>
      <a className="social-button" href="https://www.tiktok.com/@avg.collectors" target="_blank" rel="noopener noreferrer">
        <img src="/assets/svgs/tiktok.svg" alt="TikTok" />
      </a>
      <a className="social-button" href="https://www.instagram.com/avgpokecollector/" target="_blank" rel="noopener noreferrer">
        <img src="/assets/svgs/instagram.svg" alt="Instagram" />
      </a>
      </div>
    </div>
    }

const SideMenu = ({ toggleMenu, setState, recentProducts = [], onSelectRecent }) => {
  const width = useWindowWidth();
  const { user, login, logout, authReady, address } = useAuth();
  const [menuState, setMenuState] = useState(null);

  function closeMenu() {
    toggleMenu();
    setMenuState(null);
  }

  async function handleLogout() {
    try {
      await logout();
    } catch (e) {

    } finally {
      setState(STATE.OVERVIEW);
      toggleMenu();
    }
  }

  const MenuComponent = () => {

    const BaseMenu = () => {
      return <>
        <button
          className="content-header header-major "
          onClick={() => {
          setState(STATE.OVERVIEW);
          closeMenu();
          }}
        >
            <div>BROWSE</div>
          </button>

          <RecentlyViewedMenuWidget
            items={recentProducts}
            onSelect={(item) => {
              onSelectRecent?.(item);
              closeMenu();
            }}
          />

                {authReady && user ? (
                  <>

                  <button className="content-header header-major " onClick={() => {setState(STATE.WISHLIST); toggleMenu();}}>
                      <div>WISHLIST</div>
                  </button>
                  {isAdminUser(user) && (
                    <button
                      className="content-header header-major"
                      onClick={() => { setState(STATE.ADMIN_TOOLS); closeMenu(); }}
                    >
                      <div>INVENTORY ADMIN</div>
                    </button>
                  )}
                  <button className="content-header header-major " onClick={() => {setState(STATE.COLLECTIONS); toggleMenu();}}>
                    <div>COLLECTIONS</div>
                  </button>
                  <button className="content-header header-major ">
                    <div>FRIENDS</div>
                  </button>
                  </>
              ) :
                  <>
                    <button className="content-header header-major" onClick={() => setMenuState(USERSTATES.LOGIN)}>
                        <div>Login</div>
                    </button>
                    <button className="content-header header-major" onClick={() => setMenuState(USERSTATES.REGISTER)}>
                        <div>Register</div>
                    </button>
                  </>
            }
        </> 
    }

    const ProfileMenu = () => {
      return <div className="content">


        {/* <div className="menu-divider-long"></div> */}
        <button className="content-header header-minor" onClick={() => {setState(STATE.PROFILE); toggleMenu();}}>
          <div>DETAILS</div>
        </button>
        <button className="content-header header-minor" onClick={() => {setState(STATE.ORDERS); toggleMenu();}}>
          <div>ORDER HISTORY</div>
        </button>
        <button className="content-header header-minor" onClick={() => {setState(STATE.COUPONS); toggleMenu();}}>
          <div>COUPONS</div>
        </button>

        <button className="content-header header-minor" onClick={handleLogout}>
          <div>LOG OUT</div>
        </button>
      </div>
    }

    return <div className="menu-content">
      {menuState === null && <BaseMenu/>}
      {menuState === USERSTATES.PROFILE && <ProfileMenu/>}
    </div>
  }

    const MobileExitButton = () => {
      return <button type="button" onClick={() => closeMenu()}>
          <img
              src="/assets/svgs/sidebar-exit.svg"
              className="drop-down"
              alt="Close"
          />
          </button>
    }

    const LegalComponent = () => {
      return <div className="bottom-header-content">
        <button className="content-header header-minor" onClick={() => { setState(STATE.PRIVACY_POLICY); toggleMenu(); }}>
            <h2>PRIVACY POLICY</h2>
        </button>

        <button className="content-header" onClick={() => { setState(STATE.TERMS_AND_CONDITIONS); toggleMenu(); }}>
            <div className="header-minor">
                <h2>Terms & conditions</h2>
            </div>
        </button>

        <button className="content-header" onClick={() => { setState(STATE.INFO); toggleMenu(); }}>
            <div className="header-minor">
                <h2>FAQ</h2>
            </div>
        </button>

      </div>
    }

  return (
    <div id="menu">
      <div className="menu-placeholder" onClick={() => toggleMenu()}></div>

        <div className="menu-sidebar">
            <div className="menu-logo">
            <img src="/assets/logo/collectdiv.png" alt="CollectDiv" />
            </div>

            <div className="content hide-scrollbar">
            {/* Header */}
            {!authReady ? (
                <div className="header-major white">Loading…</div>
            ) : user ? (
              <div className="user-header" onClick={() => setMenuState(USERSTATES.PROFILE)}>
                <img className="avatar-small" src="/avatars/avatar.png"></img>
                <div className="header-major white">{user?.firstName || "Collector"}</div>
                {address === null && <div className="missing-info">!</div>}
              </div>
            ) : (
                <div className="header-major white">Welcome</div>
            )}
            {(menuState === USERSTATES.REGISTER) && <RegisterComponent setUserState={setMenuState} />}
            {(menuState === USERSTATES.LOGIN) && <LoginComponent setUserState={setMenuState}/>}
            {(menuState === USERSTATES.FORGOT) && <ForgotPasswordComponent/>}
            <MenuComponent/>
            <SocialComponent/>
            <LegalComponent/>
            {width < 1200 && <MobileExitButton />}
        </div>
      </div>

    </div>
  );
};

export default SideMenu;
